module.exports = __webpack_public_path__ + "img/sld_inverter_green_b1_green.12029695.svg";